import Demo from '~/components/select/demos/basic';

export default Demo;
export const example = true;